// Admin email configuration - shared between client and server
export const ADMIN_EMAILS = [
  "admin@prizo.io",
  "support@prizo.io",
  // Add more admin emails as needed
];

/**
 * Check if a user email has admin privileges (client-safe version)
 * @param email - User email to check
 * @returns boolean indicating if user is admin
 */
export function isAdminUser(email: string | null | undefined): boolean {
  return email ? ADMIN_EMAILS.includes(email) : false;
} 